const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c7c76d6abb7c868abb6e2465e33f378223d495dc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["marketing-site@gradeproof"]={id:"c7c76d6abb7c868abb6e2465e33f378223d495dc"};
      